module.exports = __webpack_public_path__ + "img/pic_menzhen.b7ec6764.png";